'use client';

import bannerImage from '@/assets/images/product-tester-page/banner.png';

import contentImage1 from '@/assets/images/product-tester-page/content-1.png';
import contentImage2 from '@/assets/images/product-tester-page/content-2.png';
import contentImage3 from '@/assets/images/product-tester-page/content-3.png';
import mobileBannerImage from '@/assets/images/product-tester-page/mobile-banner.png';
import Image from 'next/image';
import classes from './productTesterPage.module.css';

const ProductTesterPage = () => {
  return (
    <div className={classes.root}>
      <div className={classes.banner}>
        <div className={classes.bannerImage}>
          <Image
            src={mobileBannerImage}
            alt=''
            className='block h-auto w-full lg_hidden'
          />
          <Image
            src={bannerImage}
            className='hidden h-auto w-full lg_block'
            alt=''
          />
        </div>
      </div>
      <h1 className={classes.title}>Recruit Free Product Testers</h1>
      <div className={classes.contentRow}>
        <div className={classes.left}>
          <Image
            src={contentImage1}
            alt=''
          />
        </div>
        <div className={classes.right}>
          <h2 className={classes.contentTitlte}>What is a product tester?</h2>
          <p className={classes.contentText}>
            A product tester is someone who evaluates and tests products to provide feedback on their performance,
            quality, and usability. Product testers share their user experiences with us, allowing us to make
            improvements and enhancements. Their insights are invaluable to us in refining our products.
          </p>
        </div>
      </div>
      <div className={classes.contentRowReverse}>
        <div className={classes.left}>
          <h2 className={classes.contentTitlte}>What can you get as a product tester?</h2>
          <p className={classes.contentText}>
            1. Free products: Product testers will receive the product they are testing for free. This allows you to
            experience and evaluate the product.
          </p>
          <p className={classes.contentText}>
            2. Recognition and feedback: Your insights and feedback as a product tester are valuable to us. We
            acknowledge and recognize your contributions, and even solicit your opinions and suggestions for product
            improvements.
          </p>
        </div>
        <div className={classes.right}>
          <Image
            src={contentImage2}
            alt=''
          />
        </div>
      </div>
      <div className={classes.contentRow}>
        <div className={classes.left}>
          <Image
            src={contentImage3}
            alt=''
          />
        </div>
        <div className={classes.right}>
          <h2 className={classes.contentTitlte}>How to apply?</h2>
          <p className={classes.contentText}>
            It is easy to apply to become our product tester. Write an email to{' '}
            <a
              className={classes.link}
              href='mailto:bella@awbridal.com'
            >
              bella@awbridal.com
            </a>{' '}
            with the subject “I want to be become a free product tester”. We will contact you within 48 hours after
            receiving your application.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductTesterPage;
